import { Component, Input } from '@angular/core';
import { AvatarProps, avatarStyles } from '@kite_aerolab/shared/components';
import { cutText, getInitials } from '@kite_aerolab/shared/utils';

@Component({
  selector: 'kite-avatar',
  template: `
    <div [ngClass]="avatarStyles">
      <img *ngIf="src" [src]="src" [alt]="alt || 'avatar image'" />
      <kite-icon *ngIf="icon && !src" [name]="icon" size="md"></kite-icon>
      <span *ngIf="text && !icon && !src" class="avatar-text"> {{ text.length < 3 ? text : getInitials(text) }} </span>
      <span *ngIf="dot" class="dot-container">
        <kite-badge size="sm" [variant]="dot" position="topRight"></kite-badge>
      </span>
      <span *ngIf="badge && size !== 'sm'" class="badge-container">
        <kite-badge
          [variant]="badge.variant"
          size="md"
          position="bottomCenter"
          [label]="badge.text ? cutText(badge.text, 10) : ''"
        ></kite-badge>
      </span>
    </div>
  `,
})
export class AvatarComponent {
  /**
   * Tamaño del avatar: sm o md
   */
  @Input() size: AvatarProps['size'];

  /**
   * Variante del avatar. Determina su color
   */
  @Input() variant: AvatarProps['variant'];

  /**
   * Forma del avatar. Cuadrada o redonda
   */
  @Input() shape: AvatarProps['shape'];

  /**
   * imagen del avatar
   */
  @Input() src: AvatarProps['src'];

  /**
   * Texto alternativo de la imagen del avatar
   */
  @Input() alt: AvatarProps['alt'];

  /**
   * ícono del avatar
   */
  @Input() icon: AvatarProps['icon'];

  /**
   * Texto
   */
  @Input() text: AvatarProps['text'];

  /**
   * Dot del avatar
   */
  @Input() dot: AvatarProps['dot'];

  /**
   * Badge del avatar
   */
  @Input() badge: AvatarProps['badge'];

  /**
   * CSS del componente
   */
  @Input() css: AvatarProps['css'];

  public get avatarStyles(): string[] {
    return [
      avatarStyles({
        variant: this.variant,
        size: this.size,
        shape: this.shape,
        hasImage: !!this.src,
        css: this.css,
      }).className,
    ];
  }

  getInitials(name: string) {
    return getInitials(name);
  }

  cutText(text: string, max: number) {
    return cutText(text, max);
  }
}
